import { useMenuState, useClick } from "@szhsin/react-menu";
import { useEffect, useRef } from "react";
import { useClickMenu } from "./useClickMenu";

export function useReactMenuProps() {
  const profMenu = useRef(null);

  const [menuState, toggleMenu] = useMenuState({
    transition: true,
    transitionTimeout: 120,
  });
  const anchorProps = useClick(menuState.state, (open) => {
    toggleMenu(open);
  });

  const clickMenu = useClickMenu();

  return {
    controlledMenuProps: {
      anchorRef: profMenu,
      className: "cvp-react-menu",
      ...menuState,

      onClose: () => {
        if (!IS_DEBUGGING_MENU) {
          toggleMenu(false);
        }
      },
      submenuOpenDelay: clickMenu ? 999999999 : 0,
      // Give the user time to slide the mouse from the parent item over the
      // dead-zone to the submenu without it closing under them. 0 ms (the
      // default) made the menu feel actively hostile if you didn't track
      // perfectly horizontally.
      submenuCloseDelay: clickMenu ? 999999999 : 600,
    },
    btnProps: {
      ref: profMenu,
      ...anchorProps,
    },
  };
}

const IS_DEBUGGING_MENU = false;//location.origin === "https://localhost:44425";
if (IS_DEBUGGING_MENU) {
  console.warn("Debugging menu: keeping menu open indefinitely");
}
